enum EHttpStatus {
  OK = 200,
  NotFound = 404,
  BadRequest = 400,
  Unauthorized = 401,
  Forbidden = 403,
  Fatal = 500,
}

export default EHttpStatus
